import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { selectOpenNetworkProductTypesListItems } from "../../../../../redux/opennetwork-product-types/selector";
import { openNetworkProductTypes } from "../../../../../redux/opennetwork-product-types/action";
import { settings } from "../../../../../redux/settings/actions";
import UploadCommonModal from "../../../../../models/upload-common-modal";
import { toast } from "react-toastify";

const OpenNetworkProductTypes = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const result = useSelector(selectCurrent)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const { header, footer, currency } = result
  const { getUploadModal } = useAppSelector(selectCurrent)
  const opennetworkItems = useSelector(selectOpenNetworkProductTypesListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name' },
      { field: 'Type', headerName: 'Type' }
    ]);
  }

  const fetchOpenNetworkCategories = () => {
    dispatch(openNetworkProductTypes.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/opennetwork-product-types/list`,
      entity: 'openNetworkProductTypes',
      jsonData:
      {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data.Id}`)
  }

  useEffect(() => {
    createColumnDefs()
    fetchOpenNetworkCategories()
  }, [pageData, pageSize])

  const additionButtons: any = [
    // {
    //   name: 'Add Opennetwork Product Types',
    //   callback: () => handleAdd(),
    // },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
          <title>Import Product Types</title>
          <path d="M3.00012 14L3.23397 14.6626C4.14412 17.2413 4.5992 18.5307 5.63754 19.2654C6.67588 20 8.04322 20 10.7779 20H13.2224C15.957 20 17.3244 20 18.3627 19.2654C19.401 18.5307 19.8561 17.2413 20.7663 14.6626L21.0001 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M12.0001 14V4M12.0001 14C11.2999 14 9.99165 12.0057 9.50012 11.5M12.0001 14C12.7003 14 14.0086 12.0057 14.5001 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Import Product Types',
      callback: () => handleUploadProductTypesClick(),
    },
  ];

  const handleUploadProductTypesClick = () => {
    dispatch(settings.set({ getUploadModal: 'open' }))
  };

  const handleDelete = (data: any) => {
    dispatch(openNetworkProductTypes.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/opennetwork-product-types/delete`,
      entity: 'openNetworkProductTypes',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      dispatch(openNetworkProductTypes.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/opennetwork-product-types/list`,
        entity: 'openNetworkProductTypes',
        jsonData:
        {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
    });
  }

  const handleUploadClick = async (data: any) => {
    const frmData = new FormData();
    frmData.append(
      'formFile',
      data
    );
    dispatch(openNetworkProductTypes.uploadCreate({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/opennetwork-product-types/upload-open-network-product-types`,
      entity: 'uploadDomains',
      jsonData: frmData
    })).then(() => {
      toast.info('ProductType  uploading is in progress',);
      handleUploadClose()
    }).then(() => {
      dispatch(openNetworkProductTypes.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/opennetwork-product-types/list`,
        entity: 'openNetworkProductTypes',
        jsonData:
        {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
    })
  };

  const handleUploadClose = () => {
    dispatch(settings.set({ getUploadModal: 'close' }))
  }

  return (
    <>
      {getUploadModal == 'open' && <UploadCommonModal title='Upload ProductTypes' onSubmit={handleUploadClick} handleClose={handleUploadClose} />}
      {opennetworkItems?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs} rowData={opennetworkItems?.result?.items}
          setPageData={setPageData} setPageSize={setPageSize} paginationData={opennetworkItems?.result?.pagination}
          onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons}
          headingName="OpenNetwork Product Types"
        />
      }
    </>
  );
};

export default OpenNetworkProductTypes;


